var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',{attrs:{"disabled":_vm.disabled,"indeterminate":_vm.indeterminate},model:{value:(_vm.batchAll),callback:function ($$v) {_vm.batchAll=$$v},expression:"batchAll"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }